import { emptyType } from '@shared/interfaces/sharedIntrefacesAndTypes';
import { Mixin } from 'ts-mixer';

export class PaginatorData {
  first: number;
  pageSize: number; // Почему это string?
}

export class CommonFilter {
  search: string;
  officeId: number | emptyType;
  officeIds: number[];
  deleted: boolean | emptyType;
  geoUnitId: number | emptyType;
  isMaster?: boolean | emptyType;

  constructor() {
    this.deleted = '';
  }

  initializer(data: any) {
    if (data === null) {
      return;
    }
    const keys = Object.keys(data);
    if (keys.length > 0) {
      keys.forEach((key) => {
        this[key] = data[key];
      });
    }
  }
}

export class CommonFilterWithPaginator extends Mixin(CommonFilter, PaginatorData) {
  constructor() {
    super();
    this.deleted = '';
    this.first = 0;
    this.pageSize = 25;
  }
}
